import { TypeTacheService } from './../../../services/typeTache.service';
import { Typetache } from './../../../models/typetache.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-param-tache',
  templateUrl: './param-tache.component.html',
  styleUrls: ['./param-tache.component.scss']
})
export class ParamTacheComponent implements OnInit {

  typeTaches: Typetache[];
  constructor(private typeTacheService: TypeTacheService) { 
    this.typeTacheService.get_typetache().subscribe((res: Typetache[]) => {
      this.typeTaches = res;
    });
  }

  ngOnInit() {
  }

}
